import { decodeResourceToData, encodeFieldDataToResourceData } from '../../LegacyNotes.helpers';
export const ADDENDUM_DATA = {
    addendum: {
        multi: true,
        backendSchema: {
            readValuePath: ['data', 'note'],
            saveValuePath: ['data.note.text'],
        },
        customParams: {
            resourceId: {
                backendSchema: {
                    readValuePath: ['resource_id'],
                },
            },
        },
        onRead(resourcesList) {
            return decodeResourceToData(resourcesList, this);
        },
        onSave(fieldData) {
            return encodeFieldDataToResourceData(fieldData, this);
        },
    },
};
